var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"etc-applyBottom"},[_c('span',{on:{"click":_vm.m_customService}},[_vm._v("客服中心")]),(!_vm.noDetail)?_c('div',{staticClass:"line"}):_vm._e(),(!_vm.noDetail)?_c('span',{on:{"click":function($event){return _vm.m_goPages('applyDetail')}}},[_vm._v("办理详情")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }